<template>
  <div v-if="paging.total && pageSize > 1" class="paging">
    <a v-if="!isFirstPage" href="#"
      @click.prevent="onFirstClick"><img src="../../../src/assets/images/btn_1st_page.png" alt="first page"></a>
    <a v-if="hasPrevBlock" href="#"
      @click.prevent="onPrevBlockClick"><img src="../../../src/assets/images/btn_prev_page.png" alt="previous page"></a>
    <ul>
      <li v-for="pageNo in pages" :key="pageNo">
        <a href="#"
          :class="pageNo === page ? 'active' : ''"
          @click.prevent="onPageChange(pageNo)">{{ pageNo }}</a>
      </li>
    </ul>
    <a v-if="hasNextBlock" href="#" class="rotate"
      @click.prevent="onNextBlockClick"><img src="../../../src/assets/images/btn_prev_page.png" alt="next page"></a>
    <a v-if="!isLastPage" href="#" class="rotate"
      @click.prevent="onLastClick"><img src="../../../src/assets/images/btn_1st_page.png" alt="last page"></a>
  </div>
</template>

<script>
const pagingBlock = 5

export default {
  name: 'AppPaging',
  props: ['paging'],
  data () {
    return {
      total: 0,
      page: 0,
      limit: 0
    }
  },
  computed: {
    pageSize () {
      return Math.ceil(this.total / this.limit)
    },
    blockSize () {
      return Math.ceil(this.pageSize / pagingBlock)
    },
    currentBlock () {
      return Math.ceil(this.page / pagingBlock)
    },
    hasPrevBlock () {
      return this.currentBlock > 1
    },
    hasNextBlock () {
      return this.currentBlock < this.blockSize
    },
    isFirstPage () {
      return this.page === 1
    },
    isLastPage () {
      return this.page === this.pageSize
    },
    pages () {
      const pages = []
      const startPage = (this.currentBlock - 1) * pagingBlock + 1
      const endPage = Math.min(startPage + pagingBlock - 1, this.pageSize)
      for (let i = startPage; i <= endPage; i++) {
        pages.push(i)
      }
      return pages
    }
  },
  created () {
    this.setData()
  },
  watch: {
    paging: {
      deep: true,
      handler (value) {
        this.setData()
      }
    }
  },
  methods: {
    setData () {
      this.total = this.paging.total
      this.page = this.paging.page
      this.limit = this.paging.limit
    },
    onPageChange (page) {
      this.$emit('onPageChange', page)
    },
    onFirstClick () {
      this.onPageChange(1)
    },
    onLastClick () {
      this.onPageChange(this.pageSize)
    },
    onPrevBlockClick () {
      const newPage = (this.currentBlock - 1) * pagingBlock
      this.onPageChange(newPage)
    },
    onNextBlockClick () {
      const newPage = (this.currentBlock) * pagingBlock + 1
      this.onPageChange(newPage)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/global/AppPaging.vue